const cmaOps = require('./cmaOperations');
const data = require('./data/cma_bs.json');

/*
  NOTES
    > cma_bs_60 is calcuated in CF
*/

module.exports = function (cma_bs_values, cma_pl_values) {

  cma_bs_values.cma_bs_2 = cmaOps.sum(...cmaOps.childrenIds('cma_bs_2', data).map(element => cma_bs_values[element]));

  cma_bs_values.cma_bs_13 = cmaOps.sum(...cmaOps.childrenIds('cma_bs_13', data).map(element => cma_bs_values[element]));

  cma_bs_values.cma_bs_19 = cmaOps.sum(...cmaOps.childrenIds('cma_bs_19', data).map(element => cma_bs_values[element]));

  // ?? Convert it to a system where just enter the starting seq and end seq will calculate the sum of start to end ??
  cma_bs_values.cma_bs_27 = cmaOps.sum(cma_bs_values.cma_bs_6, cma_bs_values.cma_bs_7, cma_bs_values.cma_bs_8, cma_bs_values.cma_bs_9, cma_bs_values.cma_bs_10, cma_bs_values.cma_bs_11, cma_bs_values.cma_bs_12, cma_bs_values.cma_bs_13, cma_bs_values.cma_bs_19);

  cma_bs_values.cma_bs_28 = cmaOps.sum(cma_bs_values.cma_bs_2, cma_bs_values.cma_bs_27);

  // ?? Convert it to a system where just enter the starting seq and end seq will calculate the sum of start to end ??
  cma_bs_values.cma_bs_38 = cmaOps.sum(cma_bs_values.cma_bs_30, cma_bs_values.cma_bs_31, cma_bs_values.cma_bs_32, cma_bs_values.cma_bs_33, cma_bs_values.cma_bs_34, cma_bs_values.cma_bs_35, cma_bs_values.cma_bs_36, cma_bs_values.cma_bs_37);

  cma_bs_values.cma_bs_39 = cmaOps.sum(cma_bs_values.cma_bs_28, cma_bs_values.cma_bs_38);

  cma_bs_values.cma_bs_46 = cmaOps.sum(...cmaOps.childrenIds('cma_bs_46', data).map(element => cma_bs_values[element]));

  // ?? Convert it to a system where just enter the starting seq and end seq will calculate the sum of start to end ??
  cma_bs_values.cma_bs_56 = cmaOps.sum(cma_bs_values.cma_bs_41, cma_bs_values.cma_bs_42, cma_bs_values.cma_bs_43, cma_bs_values.cma_bs_44, cma_bs_values.cma_bs_45, cma_bs_values.cma_bs_46);

  cma_bs_values.cma_bs_57 = cmaOps.sum(cma_bs_values.cma_bs_39, cma_bs_values.cma_bs_56);

  cma_bs_values.cma_bs_62 = cmaOps.sum(cma_bs_values.cma_bs_63, cma_bs_values.cma_bs_64);

  cma_bs_values.cma_bs_65 = cmaOps.sum(...cmaOps.childrenIds('cma_bs_65', data).map(element => cma_bs_values[element]));

  cma_bs_values.cma_bs_71 = cmaOps.sum(...cmaOps.childrenIds('cma_bs_71', data).map(element => cma_bs_values[element]));

  cma_bs_values.cma_bs_74 = cma_pl_values.cma_pl_27;
  cma_bs_values.cma_bs_75 = cma_pl_values.cma_pl_31;

  cma_bs_values.cma_bs_76 = cmaOps.sum(...cmaOps.childrenIds('cma_bs_76', data).map(element => cma_bs_values[element]));
  cma_bs_values.cma_bs_70 = cmaOps.sum(...cmaOps.childrenIds('cma_bs_70', data).map(element => cma_bs_values[element]));

  cma_bs_values.cma_bs_81 = cmaOps.sum(...cmaOps.childrenIds('cma_bs_81', data).map(element => cma_bs_values[element]));

  cma_bs_values.cma_bs_91 = cmaOps.sum(cma_bs_values.cma_bs_92, cma_bs_values.cma_bs_93);

  cma_bs_values.cma_bs_95 = cmaOps.difference(cma_bs_values.cma_bs_91, cma_bs_values.cma_bs_94);

  cma_bs_values.cma_bs_97 = cmaOps.sum(...cmaOps.childrenIds('cma_bs_97', data).map(element => cma_bs_values[element]));

  cma_bs_values.cma_bs_103 = cmaOps.sum(...cmaOps.childrenIds('cma_bs_103', data).map(element => cma_bs_values[element]));

  cma_bs_values.cma_bs_112 = cmaOps.sum(cma_bs_values.cma_bs_97, cma_bs_values.cma_bs_100, cma_bs_values.cma_bs_101, cma_bs_values.cma_bs_102, cma_bs_values.cma_bs_103);

  cma_bs_values.cma_bs_116 = cmaOps.difference(cmaOps.sum(cma_bs_values.cma_bs_113, cma_bs_values.cma_bs_114), cma_bs_values.cma_bs_115);

  cma_bs_values.cma_bs_118 = cmaOps.difference(cma_bs_values.cma_bs_56, cma_bs_values.cma_bs_116, cma_bs_values.cma_bs_43, cma_bs_values.cma_bs_53);

  cma_bs_values.cma_bs_121 = cmaOps.divide(cma_bs_values.cma_bs_39, cma_bs_values.cma_bs_118);

  cma_bs_values.cma_bs_122 = cmaOps.divide(cma_bs_values.cma_bs_38, cma_bs_values.cma_bs_118);

  return cma_bs_values;
}



// WEBPACK FOOTER //
// ./src/cma/calculations_BS.js